import {
  createLightTheme,
  BrandVariants,
  Theme,
} from '@fluentui/react-components'
import lightTokens from './lightTokens.json'

/**
 * Define brand ramp for Fluent v9.
 * These roughly correspond to the primary color shades from v8.
 */
const brand: BrandVariants = {
  10: '#eff6fc',
  20: '#deecf9',
  30: '#c7e0f4',
  40: '#71afe5',
  50: '#2b88d8',
  60: '#0078d4',
  70: '#106ebe',
  80: '#005a9e',
  90: '#004578',
  100: '#00335a',

  // Add these extra shades to satisfy the type
  110: '#00304f',
  120: '#002d47',
  130: '#002a40',
  140: '#002739',
  150: '#002432',
  160: '#00212b',
}

/**
 * Start from the default Fluent v9 light theme and extend it with your full design token map.
 */
export const lightCustomTheme: Theme = {
  ...createLightTheme(brand),
  // This was built using v8 theme
  // https://storybooks.fluentui.dev/react/?path=/docs/migration-shims-v8-theme-createv9theme--docs
  ...lightTokens,
}
